
import React, { useState, useEffect } from 'react';
import PageTitle from '../../components/PageTitle';
import api from "../../api/axiosClient"
import genStyles from '../../styles/General.module.css'
import { Button, Checkbox, Tabs} from '@mantine/core';
import {ModelsRowType} from '../../types/models';
import {useDisclosure } from '@mantine/hooks';
import {CategoryDetailRowType, CategoryRowType} from '../../types/categories';
import CategoryList from './CategoryList';
import CategoryPopUp from './CategoryPopUp';
import { useCategories } from '../../context/CategoriesContext';

const CategoryPage = () =>{
    const [activeTab, setActiveTab] = useState<string | null>('Color');
    const { recyclingCat, setRecyclingCat, reuseCat, setReuseCat, colorCat, setColorCat, fetchCategories } = useCategories();
    const [data, setData] = useState<CategoryRowType[] | null>(null);
    const [opened, { open, close }] = useDisclosure(false);
    
    const endpoints: Record<string, string> = {
        Color: 'colors',
        Recycling: 'categories',
        Reuse: 'sorter/reuse-category',
    };

    const normalizeCategoryDetails = (details: CategoryDetailRowType[] = []) => {
        return details.map(({ textil_type_id, min_value, max_value, conv_value }) => ({
            textil_type_id: Number(textil_type_id),
            min_value: min_value === null ? null : Number(min_value),
            max_value: max_value === null ? null : Number(max_value),
            conv_value: Number(conv_value),
        }));
    };

    const deleteCategory = async (id: number) => {
        try {
            const endpoint = endpoints[activeTab ? activeTab : 'Color'];
            await api.delete(`/${endpoint}/${id}`);
            
            // local update
            if (activeTab === 'Color') {
                const updated = colorCat.filter((item) => item.id !== id);
                setColorCat(updated);
            } else if (activeTab === 'Recycling') {
                const updated = recyclingCat.filter((item) => item.id !== id);
                setRecyclingCat(updated);
            } else if (activeTab === 'Reuse') {
                const updated = reuseCat.filter((item) => item.id !== id);
                setReuseCat(updated);
            }
        } catch (error) {
            console.error("Error deleting category:", error);
        }
    }

    const addCategory = async (category: { id?: number; name: string; enable?: boolean; details?: any[] }) => {
        try {
            const endpoint = endpoints[activeTab ? activeTab : 'Color'];
            let payload: any = { name: category.name };
            const normalizedDetails = normalizeCategoryDetails(category.details || []);
            let savedCategory: CategoryRowType | undefined;

            if (activeTab === 'Recycling') {
                payload.medusa_enabled = category.enable !== undefined ? category.enable : true;
            }

            if (category.id !== undefined) {
                // UPDATE / PUT action
                const response = await api.put(`/${endpoint}/${category.id}`, payload);
                const finalResponse = activeTab === 'Recycling'
                    ? await api.patch(`/${endpoint}/${category.id}/details`, { details: normalizedDetails })
                    : response;
                savedCategory = finalResponse.data;

                if (activeTab === 'Color') {
                    setColorCat(colorCat.map(item => item.id === category.id ? finalResponse.data : item));
                } else if (activeTab === 'Recycling') {
                    setRecyclingCat(recyclingCat.map(item => item.id === category.id ? finalResponse.data : item));
                } else if (activeTab === 'Reuse') {
                    setReuseCat(reuseCat.map(item => item.id === category.id ? finalResponse.data : item));
                }
            } else {
                // CREATE / POST action
                const response = await api.post(`/${endpoint}`, payload);
                const createdCategory = activeTab === 'Recycling'
                    ? await api.patch(`/${endpoint}/${response.data.id}/details`, { details: normalizedDetails })
                    : response;
                savedCategory = createdCategory.data;

                if (activeTab === 'Color') {
                    setColorCat([...colorCat, createdCategory.data]);
                } else if (activeTab === 'Recycling') {
                    setRecyclingCat([...recyclingCat, createdCategory.data]);
                } else if (activeTab === 'Reuse') {
                    setReuseCat([...reuseCat, createdCategory.data]);
                }
            }

            await fetchCategories();
            close();
            return savedCategory;
        } catch (error) {
            console.error("Error saving category:", error);
        }
    }
    

    useEffect(() => {
        switch (activeTab) {
            case 'Color':
                setData(colorCat);
                break;
            case 'Recycling':
                setData(recyclingCat);
                break;
            case 'Reuse':
                setData(reuseCat);
                break;
            default:
                break;
        }
    },  [activeTab, recyclingCat, reuseCat, colorCat]);


    return(
        <div>
            <CategoryPopUp opened={opened} close={close} title={`Add ${activeTab} Category`} onSave={addCategory} categories={data ?? []}></CategoryPopUp>
            <PageTitle title="Categories" />
            <div className={genStyles.PageMain}> 
                <Tabs  color="#474973" radius="md" value={activeTab} onChange={setActiveTab}>
                <div className={genStyles.TabsHeaderRow}> 
                      <Tabs.List>
                          <Tabs.Tab className={genStyles.Tab} value="Color">Colors</Tabs.Tab>
                          <Tabs.Tab className={genStyles.Tab} value="Recycling">Recycling</Tabs.Tab>
                          <Tabs.Tab className={genStyles.Tab} value="Reuse">Reuse</Tabs.Tab>
                      </Tabs.List>
                </div>
                      <Tabs.Panel value="Color">
                          <CategoryList data={data} activeTab={activeTab} onDelete={deleteCategory} onSave={addCategory}></CategoryList>
                      </Tabs.Panel>  
                      <Tabs.Panel value="Recycling">
                           <CategoryList data={data} activeTab={activeTab} onDelete={deleteCategory} onSave={addCategory}></CategoryList>
                      </Tabs.Panel>
                      <Tabs.Panel value="Reuse">
                           <CategoryList data={data} activeTab={activeTab} onDelete={deleteCategory} onSave={addCategory}></CategoryList>
                      </Tabs.Panel>
              </Tabs>   

              <div className={genStyles.AddButtonWrapper}> 
                 <Button className ={genStyles.AddButton}  onClick={open} variant="filled" color="#62929E" radius="xl">Add</Button>
                </div>

            </div>
        </div>
    )
}

export default CategoryPage;